const { ABILITY_POINTS_PER_LEVEL } = require('../constants/Balance');

const getAvailableAbilityPoints = ({ built_hero, roster_hero }) => {
  if (built_hero.hero_handle !== roster_hero.handle) {
    throw new Error('[getAvailableAbilityPoints] hero mismatch', {
      built_hero,
      roster_hero,
    });
  }

  const total_points = ABILITY_POINTS_PER_LEVEL * roster_hero.level;

  const total_spent =
    Object.values(built_hero.ability_upgrades || {})
      // ability upgrades
      .reduce((n, tree_abilities) => {
        // Handle null/undefined tree values
        if (tree_abilities && typeof tree_abilities === 'object') {
          for (const ability_level of Object.values(tree_abilities)) {
            n += ability_level || 0;
          }
        }
        return n;
      }, 0) +
    Object.values(built_hero?.affinities?.attack ?? {})
      // attack affinities
      .reduce((n, val) => n + (val || 0), 0) +
    Object.values(built_hero?.affinities?.defense ?? {})
      // defense affinities
      .reduce((n, val) => n + (val || 0), 0);

  return total_points - total_spent;
};
module.exports = getAvailableAbilityPoints;
